(function($) {

$.fn.tabs = function() {

    var tabs = document.querySelectorAll('.tabs__tab-button');
    var tabsArr = Array.prototype.slice.call(tabs);
    
    // The tab switching function
    var switchTab = function(oldTab, newTab) {

        //find this newTab panels and tab group
        var tabGroup = newTab.closest('.tabs__navigation').querySelectorAll('.tabs__tab-button');
        var panels = newTab.closest('.tabs').querySelectorAll('[id^="tab-panel"]');

        newTab.focus();
        // Make the active tab focusable by the user (Tab key)
        newTab.removeAttribute('tabindex');
        // Set the selected state
        newTab.setAttribute('aria-selected', 'true');
        oldTab.setAttribute('aria-selected', 'false');
        
        // oldTab.removeAttribute('aria-selected');
        oldTab.setAttribute('tabindex', '-1');
        // Get the indices of the new and old tabs to find the correct
        // tab panels to show and hide
        var index = Array.prototype.indexOf.call(tabGroup, newTab);
        var oldIndex = Array.prototype.indexOf.call(tabGroup, oldTab);

        //window.location.hash = newTab.getAttribute("href");
        
        panels[oldIndex].hidden = true;
        panels[index].hidden = false;

    };

    //loop through all tabs
    tabsArr.forEach(function(tab, i) {

        // Handle clicking of tabs for mouse users
        tab.addEventListener('click', function(e) {
            e.preventDefault();
            var currentTab = tab.closest('.tabs__navigation').querySelector('[aria-selected="true"]');
            if (e.currentTarget !== currentTab) {
                console.log('switching tab from', currentTab, 'to', e.currentTarget);
                switchTab(currentTab, e.currentTarget);
            }
        });

        // Handle keydown events for keyboard users
        tab.addEventListener('keydown', function(e) {
            // Get the index of the current tab in the tabs node list
            var targetGroup = tab.closest('.tabs__navigation').querySelectorAll('.tabs__tab-button');
            var targetPanels = tab.closest('.tabs').querySelectorAll('[id^="tab-panel"]');

            var index = Array.prototype.indexOf.call(targetGroup, e.currentTarget);
            
            // Work out which key the user is pressing and
            // Calculate the new tab's index where appropriate
            //console.log(e.which);
            var dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
            if (dir !== null) {
                e.preventDefault();
                // If the down key is pressed, move focus to the open panel,
                // otherwise switch to the adjacent tab
                if (dir === 'down') {
                    targetPanels[index].focus();
                } else if (targetGroup[dir]) {
                    switchTab(e.currentTarget, targetGroup[dir]);
                }
            }
        });

    });
    
};

})(jQuery);
